"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFile = exports.MediaWithMimeType = exports.Media = void 0;
const react_1 = __importStar(require("react"));
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const auth_1 = require("firebase/auth");
const util_1 = require("./util");
const react_hook_retention_cache_1 = require("@smart-hook/react-hook-retention-cache");
const promise_1 = require("utils/promise");
const auth = (0, auth_1.getAuth)(firebase_app_1.default);
const Media = (props) => {
    const { src, elementType } = props;
    const metadata = useMetadata(src);
    const copiedProps = (0, util_1.removeKey)(Object.assign({}, props), "elementType");
    if (metadata) {
        const Element = elementType;
        return react_1.default.createElement(Element, Object.assign({}, copiedProps, { src: metadata.url }));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.Media = Media;
const MediaWithMimeType = (props) => {
    const { src, elementType } = props;
    const metadata = useMetadata(src);
    const copiedProps = (0, util_1.removeKey)(Object.assign({}, props), "elementType");
    if (metadata) {
        const Element = elementType;
        return (react_1.default.createElement(Element, Object.assign({}, copiedProps, { src: metadata.url, mimeType: metadata.contentType })));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.MediaWithMimeType = MediaWithMimeType;
const getMetadata = (src) => __awaiter(void 0, void 0, void 0, function* () {
    if (!src) {
        return undefined;
    }
    const parsedUrl = (0, util_1.decodeSrc)(src);
    const { protocol, path, host, url, contentType } = parsedUrl;
    if (["http", "https", "data"].includes(protocol) && url) {
        return { url, contentType };
    }
    else if (protocol === "gs" && path && host) {
        return getGoogleStorageMetadata({ path, host });
    }
    else {
        throw new Error("invalid protocol");
    }
});
const metadataPromiseCache = (0, react_hook_retention_cache_1.retentionCache)({
    generator: getMetadata,
    cleanUp: () => { },
    retentionTime: 1000,
});
const usePromiseResolver = (0, promise_1.createPromiseResolverHook)();
const useMetadata = (src) => {
    const metadataPromise = (0, react_hook_retention_cache_1.useCachedValue)(src, metadataPromiseCache);
    const result = usePromiseResolver(metadataPromise);
    // Error boundaryでキャッチできるようにする
    (0, react_1.useMemo)(() => {
        if (result === null || result === void 0 ? void 0 : result.error)
            throw result.error;
    }, [result === null || result === void 0 ? void 0 : result.error]);
    return result === null || result === void 0 ? void 0 : result.value;
};
const getFile = (src) => __awaiter(void 0, void 0, void 0, function* () {
    const metadata = yield getMetadata(src);
    if (!metadata) {
        return undefined;
    }
    const { url } = metadata;
    const response = yield fetch(url);
    return response.blob();
});
exports.getFile = getFile;
const getGoogleStorageMetadata = (_a) => __awaiter(void 0, [_a], void 0, function* ({ path, host, }) {
    var _b;
    const objectUrl = `https://firebasestorage.googleapis.com/v0/b/${host}/o/${encodeURIComponent(path.replace(/^\//, ""))}`;
    const response = yield fetch(objectUrl, {
        headers: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            authorization: `Firebase ${(_b = auth === null || auth === void 0 ? void 0 : auth.currentUser) === null || _b === void 0 ? void 0 : _b.accessToken}`,
        },
    });
    const metaData = yield response.json();
    const { downloadTokens, contentType } = metaData;
    const url = `${objectUrl}?alt=media&token=${downloadTokens}`;
    return { url, contentType };
});
